import { render, staticRenderFns } from "./InfoAnimButton.vue?vue&type=template&id=c3c3cfdc&scoped=true"
import script from "./InfoAnimButton.vue?vue&type=script&lang=js"
export * from "./InfoAnimButton.vue?vue&type=script&lang=js"
import style0 from "./InfoAnimButton.vue?vue&type=style&index=0&id=c3c3cfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c3cfdc",
  null
  
)

export default component.exports